import React from "react";

import { Row, Col } from "../Component";
import RichTextEditor from "../input/rich-text/RichTextEditor";
import { LANGUAGE_KEYS } from "../../utilities/constants";

export const LANGUAGES = [
  { key: LANGUAGE_KEYS.UZ, short: "UZ", placeholder: "O'zbekcha" },
  { key: LANGUAGE_KEYS.RU, short: "RU", placeholder: "На русском" },
  { key: LANGUAGE_KEYS.EN, short: "EN", placeholder: "In English" },
];

// Bitta maydonning uchala tildagi ko'rinishi. value — { uzUZ, ruRU, enUS }.
// isRichText bo'lsa har bir til uchun alohida Slate editor chiziladi.
const MultiLanguageInput = ({
  label,
  value,
  onChange,
  isRichText = false,
  hint,
  bare = false,
}) => {
  const handleChange = (languageKey, newValue) =>
    onChange({ ...value, [languageKey]: newValue });

  const content = (
    <>
      {isRichText ? (
        LANGUAGES.map((language) => (
          <div className="mb-3" key={language.key}>
            <div className="overline-title text-soft mb-1">
              {language.short}
            </div>
            <RichTextEditor
              value={value?.[language.key]}
              setValue={(newValue) => handleChange(language.key, newValue)}
              autoFocus={false}
            />
          </div>
        ))
      ) : (
        <Row>
          {LANGUAGES.map((language) => (
            <Col md="4" className="mb-2 mb-md-0" key={language.key}>
              <div className="overline-title text-soft mb-1">
                {language.short}
              </div>
              <input
                type="text"
                className="form-control"
                placeholder={language.placeholder}
                value={value?.[language.key] ?? ""}
                onChange={(e) => handleChange(language.key, e.target.value)}
              />
            </Col>
          ))}
        </Row>
      )}
    </>
  );

  if (bare) return content;

  return (
    <div className="border rounded p-3 mb-3 bg-white">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <label className="form-label mb-0">{label}</label>
        {hint && <span className="form-note m-0">{hint}</span>}
      </div>
      {content}
    </div>
  );
};

export default MultiLanguageInput;
